import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMedium = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Medium"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle cx={10} cy={10} r={7} fill="#F19325" />
  </svg>
);
export default SvgMedium;
